import React, { Fragment } from 'react';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

import './breadcrumbs.scss';
export const Breadcrumbs = ({
    routes = []
}) => {
    const hasNextRoute = (index) => (routes[index + 1]);
    return (
        <div className='breadcrumbs-container'>
            <div className='breadcrumbs-row'>
                { routes.some(x => x != undefined) &&
                <>
                <HomeRoundedIcon className='home-icon' />
                <Divider>/</Divider>
                </>
                }
                {routes.map((route, index) => (
                    route && 
                    <Fragment key={route}>
                        <span className='breadcrumb-route'>
                            {route}
                        </span>
                        {hasNextRoute(index) && (
                            <Divider>/</Divider>
                        )}
                    </Fragment>
                ))}
            </div>
        </div>
    );
}

const Divider = ({ children }) => (
    <div className='breadcrumb-divider'>
        {children}
    </div>
);
